import { gql } from '@apollo/client';

/**
 * GraphQL mutation for updating a community.
 * Supports updating name, optionalMetadata, and securityGroups.
 */
export const UPDATE_COMMUNITY = gql`
  mutation UpdateCommunity($id: ID!, $input: UpdateCommunityInput!) {
    updateCommunity(id: $id, input: $input) {
      id
      name
      communityGroupId
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
      }
      securityGroups {
        admin
        moderator
        user
      }
      createdAt
      createdBy
      lastModifiedAt
      lastModifiedBy
    }
  }
`;
